<loading *ngIf="!isLoaded"></loading>

<div *ngIf="isLoaded && courseVendors.length > 0">

    <div style='font-size:1.2em;' class="groupTitle">Vendors</div>

    <div style='margin-top: 1.0em;'>
        <app-open-button (click)="open()" *ngIf="!showVendors">Visit Vendors</app-open-button>
        <app-open-button (click)="close()" *ngIf="showVendors">Return to Event</app-open-button>
    </div>
    
    <div *ngIf="showVendors">
        <div class='row details-body'>
            <div class='col-sm-12'>
                <div *ngIf='errorMsg' class='text-center alert-text'>{{errorMsg}}</div>

                <div *ngIf="!loadingError">

                    <div class='index'>
                        <div *ngFor="let courseVendor of courseVendors" class='row'>
                            <app-landing-page-course-vendor [course]="course" [courseVendor]="courseVendor"></app-landing-page-course-vendor>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>